export const SESSION_STORAGE_KEY = {
  shouldAlert: 'shouldAlert',
  shouldDisplayFreeTrialModal: 'shouldDisplayFreeTrialModal',
} as const

export const setShouldAlert = (value: boolean) =>
  sessionStorage.setItem(SESSION_STORAGE_KEY.shouldAlert, value.toString())
export const shouldAlert = () =>
  sessionStorage.getItem(SESSION_STORAGE_KEY.shouldAlert) !== 'false'
export const shouldDisplayFreeTrialModal = () =>
  sessionStorage.getItem(SESSION_STORAGE_KEY.shouldDisplayFreeTrialModal) !==
  'false'
export const setShouldDisplayFreeTrialModal = (value: boolean) =>
  sessionStorage.setItem(
    SESSION_STORAGE_KEY.shouldDisplayFreeTrialModal,
    value.toString(),
  )
